import React from "react";
import { FieldRenderProps } from "react-final-form";

import { FormLabel, FormControlLabel, FormGroup } from "@material-ui/core";
import Switch, { SwitchProps } from "@material-ui/core/Switch";

import withFieldControl from "../FieldControl";

import { Container } from "./styles";

type Props = {
  title?: string;
  label?: string;
} & SwitchProps;

class SwitchFieldControl extends React.Component<
  Props & FieldRenderProps<any>
> {
  onClick = () => {
    const { input } = this.props;
    const event: any = {
      target: { value: !input.value },
    };
    input.onChange(event);
  };

  render() {
    const { input, title, label, checked, ...props } = this.props;

    return (
      <Container>
        <FormLabel>{title}</FormLabel>
        <FormGroup row>
          <FormControlLabel
            label={label}
            labelPlacement="end"
            control={
              <Switch
                {...props}
                checked={!!input.value || checked}
                onClick={this.onClick}
              />
            }
          />
        </FormGroup>
      </Container>
    );
  }
}

export default withFieldControl(SwitchFieldControl);
